import O1HD, {modules, services} from "../../../../engines/gameEngine";
import gameConfig from "../../../../engines/configs/gameConfig";
import {REWARD_TYPE} from "../../../../engines/services/userContent/userInterface";
import data_control from "../../../../engines/libs/data_control";
import LocalMagicGmNode, { getSpecialCity, getSpecialProvince } from "./LocalMagicGmNode";
import getOneBundle, { BUNDLE_SMALL_NAME } from "../../BundleResourceConfig";
import LocalMagicWashCard from "./LocalMagicWashCard";
import LocalMagicContentItem from "./LocalMagicContentItem";
import { getAnswerItemByWeight } from "./LocalMagicallAnswerConfig";
import LocalMagicStep5Node from "./LocalMagicStep5Node";

const {ccclass, property} = cc._decorator;
/**
 *
 */
@ccclass
export default class LocalMagicLayer extends cc.Component {

    @property(cc.Node)
    stepNodeArray : cc.Node[] = [];
    @property(cc.Node)
    round1Node : cc.Node = null;
    @property(cc.Node)
    round2Node : cc.Node = null;
    @property(cc.Node)
    round3Node : cc.Node = null;
    @property(cc.Node)
    contentItemNode : cc.Node = null;

    @property(cc.Node)
    btnShare : cc.Node = null;
    @property(cc.Node)
    btnGoOn : cc.Node = null;
    @property(cc.Node)
    btnAgain : cc.Node = null;

    @property({type:cc.Label,displayName:"地方"})
    lbCity : cc.Label = null;
    @property({type:cc.Node,displayName:"欢迎节点"})
    welcomeNode : cc.Node = null;
    @property({type:cc.Label,displayName:"展示内容"})
    lbShowContent : cc.Label = null;
    @property({type:cc.Node,displayName:"洗牌1Node"})
    xipai1Node : cc.Node = null;
    @property({type:cc.Node,displayName:"洗牌2Node"})
    xipai2Node : cc.Node = null;

    @property({type:cc.Node,displayName:"洗牌预制体节点"})
    washCardPrefab : cc.Node = null;
    @property({type:cc.Node,displayName:"再看一次"})
    btnWatchAgainNode : cc.Node = null;
    @property(cc.Node)
    handNode : cc.Node = null;
    
    @property({type:cc.Node,displayName:"GM节点"})
    gmNode:cc.Node = null;

    //当前游戏步骤
    private mCurrStep : number = 1;
    //当前游戏权重
    private mWeight : number = 0;

    province : string = "未知";
    city : string = "未知";

    oneStr:string = null;
    twoStr:string = null;

    onLoad () {

    }

    async start () {
        let bundle = await getOneBundle( BUNDLE_SMALL_NAME.localMagic );

        O1HD.getManagers().soundMgr.playMusic("bgm", BUNDLE_SMALL_NAME.localMagic);
        O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStart({duration:60});
        O1HD.getModules().gameHttpModule.getLocalPropertyInfo(( res )=>{
            if ( res ){
                if(res.province != null){
                    this.province = res.province;
                }
                if(res.city != null){
                    this.city = res.city;
                }

                if (this.province == "未知" ){
                    this.province = getSpecialProvince()[ Math.floor(Math.random() * getSpecialProvince().length ) ];
                }
                if (this.city == "未知" ) {
                    this.city = getSpecialCity()[ Math.floor(Math.random() * getSpecialCity().length ) ];
                }
            }
        });

        if(O1HD.getServices().ossSrv.getPlatform() == "h5"){
            this.gmNode.active = true;
            await new Promise<void>(resolve=>{
                this.gmNode.getComponent(LocalMagicGmNode).complete = resolve;
            });
        }

        this.scheduleOnce(()=>{
            this.welcomeNode.active = false;
            this.showGuideStr();
        },2 );

        this.scheduleOnce(()=>{
            // 播放欢迎语音
            this.playSound("welcome",()=>{

            });
        }, 2.5 );

        //@ts-ignore
        // let provs = DC.getProvs();
        // console.log("provs",provs);
    }

    private readonly guideStrArray : string[] = ["你相信这个世界上有读心术吗？","只需要三秒钟","我就可以隔着屏幕猜到你所在的城市","不信是吧"];
    /**
     * 展示引导语句
     */
    showGuideStr( index : number  = 0 ){
        if ( index == this.guideStrArray.length ) {
            // 开始播放 拉牌语音  开始拉牌动画
            this.playSound("washCard");
            this.lbShowContent.node.active = false;
            this.handNode.active = false;

            this.xipai1Node.active = true;
            this.scheduleOnce(()=>{
                this.xipai1Node.active = false;
                // 开始播放 拉牌语音
                this.playSound("washCard");
                this.xipai2Node.active = true;
            },1.2 );

            this.scheduleOnce(async ()=>{
                this.xipai2Node.active = false;
                // 开始进入翻牌阶段
                // 播放翻牌前的提示语音
                this.showTalkStr(0,["OK,请你从这堆扑克牌中找出你在的省份","准备好了吗？不要眨眼","3,2,1"])
                this.playSound("fanCard",async ()=>{
                    await this.washCardPrefab.getComponent( LocalMagicWashCard ).showAni();
                    // 显示再来一次
                    this.showTalkStr(0,["没找到吧,我们再来一次,这次我们慢点"],5);
                    this.playSound("watchAgain",()=>{
                        this.btnWatchAgainNode.active = true;
                    });
                });
                this.washCardPrefab.getComponent( LocalMagicWashCard ).excludeAry.push(this.province);
                this.washCardPrefab.active = true;
            },2.4);
        }else{
            this.lbShowContent.string = `${this.guideStrArray[index++]}`;
            if( index + 1 == this.guideStrArray.length ){
                this.handNode.active = true;
            }
            this.lbShowContent.node.active = true;
            this.lbShowContent.node.opacity = 0;
            cc.tween( this.lbShowContent.node )
                .to( 0.5,{ opacity : 255 })
                .delay( 2.8 )
                .to( 0.5 , {opacity : 0 })
                .call(()=>{
                    this.showGuideStr( index );
                }).start();
        }
    }

    playSound(name: string, callb?: (clip: cc.AudioClip) => void) {
        O1HD.getManagers().soundMgr.playSound(name, callb, BUNDLE_SMALL_NAME.localMagic
        ).then();
    }

    /**
     * 展示引导语句
     */
    showTalkStr( index : number  = 0 , talkStrArray : string[] = null , showSeconds : number = 3.3 ){
        if ( index == talkStrArray.length ) {
            // 结束
        }else{
            this.lbShowContent.string = `${talkStrArray[index++]}`;
            this.lbShowContent.node.active = true;
            this.lbShowContent.node.opacity = 0;
            cc.tween( this.lbShowContent.node )
                .to( 0.5,{ opacity : 255 })
                .delay( showSeconds )
                .to( 0.5 , {opacity : 0 })
                .call(()=>{
                    this.showTalkStr( index , talkStrArray , showSeconds );
                }).start();
        }
    }

    @property({type:cc.Node,displayName:"揭秘Node"})
    jieMiNode : cc.Node = null;
    @property({type:cc.Label,displayName:"揭秘上部名称"})
    jieMiTopName : cc.Label = null;
    @property({type:cc.Label,displayName:"揭秘下部名称"})
    jieMiBottomName : cc.Label = null;

    /**
     * 再看一次
     */
    async onBtnWatchAgain(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.btnWatchAgainNode.active = false;
        this.washCardPrefab.getComponent( LocalMagicWashCard ).changeOnceTime(0.15 );
        await this.washCardPrefab.getComponent( LocalMagicWashCard ).restartAni();
        this.washCardPrefab.active = false;
        // 进入播放语音，交代省份环节
        this.showTalkStr(0,["是不是很奇怪没有找到?","嗯..你找的就是这张,对吧?"],2.6 );
        this.playSound("jieMi",()=>{
            this.showTalkStr(0,["不用惊讶,这只是读心术的冰山一角","接下来","请你回答我四个问题","我将读出你的城市","当然,你也可以说谎"],2 );
            this.playSound("noSurprise",()=>{
                this.round1Node.active = false;
                this.round2Node.active = true;
            } );
        });
        this.jieMiTopName.string = `${this.province}`;
        this.jieMiBottomName.string = `${this.province}`;
        this.scheduleOnce(()=>{
            this.jieMiNode.active = true;
        },3.6 );
    }

    touchScene(e: cc.Event.EventTouch) {

    }

    /**
     * 打开结果页面
     */
    async openResultPage(){
        O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStop();
        this.round2Node.active = false;
        this.round3Node.active = true;
        if ( this.city && this.city != "未知" ) {

            //成功
          
        }else{
            //失败
           
        }
    }

    /**
     *
     */
    loadContentItem( index,dataList ,callback) {
        if ( index == dataList.length ) {
            callback && callback();
            return;
        }
        let contentItemNew = cc.instantiate( this.contentItemNode );
        let content = `${dataList[index]}`;
        switch ( index ) {
            case 0:this.playSound("xyj1");break;
            case 1:this.playSound("xyj2");break;
            case 2:this.playSound("xyj3");break;
            case 3:this.playSound("xyj4");break;
        }
        contentItemNew.getComponent(LocalMagicContentItem).bindData( content,()=>{
            this.scheduleOnce(()=>{
                this.loadContentItem( ++index , dataList ,callback);
            },1.1 );
        });
        let contentNode1 : cc.Node = this.round3Node.getChildByName("contentNode1");
        contentNode1.addChild( contentItemNew );
    }


    loadFailContentItem( index,dataList ,callback) {
        if ( index == dataList.length ) {
            callback && callback();
            return;
        }
        let contentItemNew = cc.instantiate( this.contentItemNode );
        let content = `${dataList[index]}`;
        contentItemNew.getComponent(LocalMagicContentItem).bindData( content,()=>{
            this.loadFailContentItem( ++index , dataList ,callback);
        });
        let contentNode1 : cc.Node = this.round3Node.getChildByName("contentNode1");
        contentNode1.addChild( contentItemNew );
    }

    /**
     * 加载名字
     */
    loadCity( ){
        this.lbCity.string = `${this.city}`;
        this.lbCity.node.opacity = 0;
        this.lbCity.node.active = true;
        cc.tween( this.lbCity.node )
            .to( 1,{opacity:255})
            .start();
    }


    onRefresh(){
        this.round2Node.active = true;
        this.mCurrStep = 1;
        this.mWeight = 0;

        this.stepNodeArray[0].active = true;
        this.stepNodeArray[8].active = false;
        this.round3Node.getChildByName("contentNode1").destroyAllChildren();
        this.btnGoOn.active = false;
        this.btnAgain.active = false;
        this.btnShare.active = false;
        O1HD.emit("pageItem.chooseIndex",this.mCurrStep-1 );

        O1HD.getServices().miniGameSrv.getAppApiInstance().gameRecordStart({duration:60});
    }

    @property(cc.Node)
    step5Node : cc.Node = null;
    /**
     * 选择
     * @param e
     * @param flag
     */
    onBtnChoose( e , flag : string ){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        if ( this.mCurrStep == 9 ) {
            //世界结果值
            let answerItem = getAnswerItemByWeight( this.mWeight+1 );
            // 出结果
            // this.lbResult.string = `您的答案是:${answerItem}`;
            // this.openResultPage();
        }else{
            //下一个步骤
            this.stepNodeArray[this.mCurrStep++ -1].active = false;
            if ( this.mCurrStep == 5 ){
                //初始化
                let randCitys = getSpecialCity().concat();
                randCitys = data_control.randomSortArray(randCitys);
                let firstErrorCity = randCitys.pop();
                let secondErrorCity = randCitys.pop();
                if ( this.city == "未知" ){
                    let tempCityArray = getSpecialCity().concat([]);
                    let canChooseCityArray = tempCityArray.filter(item=>{ return item != this.city });
                    firstErrorCity = canChooseCityArray.splice( Math.floor( Math.random() * canChooseCityArray.length) , 1 )[0];
                    secondErrorCity = canChooseCityArray.splice( Math.floor( Math.random() * canChooseCityArray.length) , 1 )[0];
                }else{
                    //@ts-ignore
                    let provs = DC.getProvs();
                    let provinceObj = provs.find( item =>{ return item.name.includes(this.province.substring(0,2));});
                    if(provinceObj){
                        let cityIdArray = [] ;
                        for ( let id in provinceObj.mapCityId ) {
                            if ( provinceObj.mapCityId[id].name.includes(this.city.substring(0,2)) == false ) {
                                cityIdArray.push( provinceObj.mapCityId[id] );
                            }
                        }
                        if(cityIdArray.length > 2){
                            firstErrorCity = cityIdArray.splice( Math.floor( Math.random() * cityIdArray.length ) , 1 )[0]._name;
                            secondErrorCity = cityIdArray.splice( Math.floor( Math.random() * cityIdArray.length ) , 1 )[0]._name;
                        }
                    }
                }

                if(this.oneStr != null) {
                    firstErrorCity = this.oneStr;
                }
                if(this.twoStr != null){
                    secondErrorCity = this.twoStr;
                }
                //
                this.showTalkStr( 0 , ["接下来就是见证奇迹的时刻"] );
                this.playSound("miracle",()=>{
                    this.step5Node.getComponent( LocalMagicStep5Node ).setData( firstErrorCity , this.city , secondErrorCity );
                    this.stepNodeArray[this.mCurrStep-1].active = true;
                });
            }else{
                this.stepNodeArray[this.mCurrStep-1].active = true;
            }
            O1HD.emit("pageItem.chooseIndex",this.mCurrStep-1 );
        }
    }

    /**
     * 展示结果页面
     */
    onBtnShowResultPage(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        // 胜利
    }

    /**
     * 第一环节点击
     */
    round1Click(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        cc.tween( this.round1Node.getChildByName("label1") )
            .to(1,{ opacity : 50 })
            .call(()=>{
                this.round1Node.active = false;
                this.round2Node.active = true;
            }).start();
        cc.tween( this.round1Node.getChildByName("label2") )
            .to(1,{opacity:50})
            .start();
    }

    /**
     * 返回
     */
    onBtnBack(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        O1HD.getManagers().soundMgr.stopMusic();
        
    }

    /**
     * 重玩
     */
    onBtnAgain(){
        O1HD.getManagers().soundMgr.playSound("anNiu").then();
        this.round3Node.active = false;
        this.onRefresh();
    }

    // update (dt) {}
}